import { Row, Col, Card, Form, Table, Button, Input, Tag, Tabs, Tooltip, Select, Modal } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import { useNavigate } from "react-router";
import apiPath from "../../constants/apiPath";
import { PRICE } from "../../constants/conts";
import moment from 'moment';
import { DownloadExcel, SampleFileDownload } from "../../components/ExcelFile";
import ShowTotal from "../../components/ShowTotal";
const Search = Input.Search;
const { TabPane } = Tabs;


export const QuoteStatus = {
  REQUEST: "request",
  RECEIVED: "received",
  COMPLETE: "complete",
  FULLFILL: "fulfill",
};

function Index() {

  const sectionName = "Quote";
  const routeName = "quote";

  const api = {
    status: apiPath.statusQuote,
    list: apiPath.listQuote
  }

  const [searchText, setSearchText] = useState('');
  const { request } = useRequest()
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const navigate = useNavigate();
  const [selectedQuote, setSelectedQuote] = useState();
  const [categoryIds, setCategoryIds] = useState([]);
  const [brandIds, setBrandIds] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [modal, showModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState('all');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const path = urlParams.get('tab');
    switch (path) {
      case QuoteStatus.REQUEST: return setSelectedTab(QuoteStatus.REQUEST)
      default:
        break
    }
  }, [])

  const view = (id) => {
    navigate(`/pimptup-admin/${routeName}/view/${id}`)
  }

  const getBrandList = () => {
    request({
      url: apiPath.brandList,
      method: 'GET',
      onSuccess: (data) => {
        setBrandList(data.data);
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  };

  const getCategoryList = () => {
    request({
      url: apiPath.categoryList,
      method: 'GET',
      onSuccess: (data) => {
        setCategoryList(data.data);
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  };

  const handleReset = (e) => {
    setBrandIds([])
    setCategoryIds([])
  }

  // const handleSort = (e) => {
  //   const sortedList = list.sort((a, b) => a.name - b.name)
  //   setList(sortedList);

  //   // setLoading(true)
  //   // const payload = {};
  //   // payload.page = pagination ? pagination.current : 1;
  //   // payload.limit = pagination ? pagination?.pageSize : 10;
  //   // payload.status = selectedTab ? selectedTab : "all";
  //   // payload.search = debouncedSearchText;
  //   // payload.brand_ids = brandIds ? brandIds : "";
  //   // payload.category_ids = categoryIds ? categoryIds : "";
  //   // request({
  //   //   url: api.list,
  //   //   method: 'POST',
  //   //   data: payload,
  //   //   onSuccess: (data) => {
  //   //     setLoading(false)
  //   //     setList(data.data.list.docs)
  //   //     setPagination(prev => ({ ...prev, current: pagination.current, total: data.data.list.totalDocs }))
  //   //   },
  //   //   onError: (error) => {
  //   //     setLoading(false)
  //   //     ShowToast(error, Severty.ERROR)
  //   //   }
  //   // })
  // }

  const columns = [
    {
      title: "Customer Name",
      dataIndex: "name",
      render: (_, { user_id }) => {
        return user_id ? <a target="_blank" rel="noreferrer noopener" className="cap" href={`/user/customer/view/${user_id._id}`}>{(user_id ? user_id.name : '-')}</a> : '-';
      },
      sorter: (a, b) => {
        let nameA = a.user_id.name.toLowerCase()
        let nameB = b.user_id.name.toLowerCase();
        if (nameA < nameB)
          return -1;
        if (nameA > nameB)
          return 1;
        return 0;
      },
    },
    {
      title: "Vehicle Details",
      dataIndex: "make_id",
      key: "make_id",
      render: (_, { vehicle_id, make_id, model_id, type_id, variant_id }) => {
        return model_id ? 
        <span className="cap">
          <span style={{fontWeight: "500"}}>Type : </span>{`${type_id?.name || '-'}`}
          <br />
          <span style={{fontWeight: "500"}}>Make : </span>{`${make_id?.name || '-'}`}
          <br />
          <span style={{fontWeight: "500"}}>Model : </span>{`${model_id?.name || '-'}`}
          <br />
          <span style={{fontWeight: "500"}}>Variant : </span>{`${variant_id?.name || '-'}`}
          <br />
          <span style={{fontWeight: "500"}}>VIN Number : </span>{`${vehicle_id?.vin_number || '-'}`}
        </span> : 'No Vehicle Found';
      },
      /* sorter: (a, b) => {
        let nameA = a.make_id?.name.toLowerCase()
        let nameB = b.make_id?.name.toLowerCase();
        if (nameA < nameB)
          return -1;
        if (nameA > nameB)
          return 1;
        return 0;
      }, */
    },
    {
      title: "Category",
      dataIndex: "category_id",
      key: "category_id",
      render: (_, { category_id }) => {
        return category_id ? <span className="cap">{category_id.name}</span> : '-';
      },
      sorter: (a, b) => {
        let nameA = a.category_id?.name.toLowerCase()
        let nameB = b.category_id?.name.toLowerCase();
        if (nameA < nameB)
          return -1;
        if (nameA > nameB)
          return 1;
        return 0;
      },
    },
    {
      title: "Part Number",
      dataIndex: "part_number",
      key: "part_number",
      render: (_, { part_number, _id }) => {
        return part_number ? part_number : '-';
      },
    },
    {
      title: "Part Type",
      dataIndex: "part_type",
      key: "part_type",
      render: (_, { part_type }) => {
        return part_type ? <span className="cap">{part_type}</span> : '-';
      },
    },
    // {
    //   title: "Location",
    //   dataIndex: "location",
    //   key: "location",
    //   render: (_, { location }) => {
    //     return location ? <span className="cap">{location}</span> : '-';
    //   },
    // },
    // {
    //   title: "Amount (" + PRICE + ")",
    //   dataIndex: "amount",
    //   key: "amount",
    //   render: (_, { amount }) => {
    //     return amount ? amount : '-';
    //   },
    // },
    {
      title: "Status",
      key: "status",
      render: (_, { status, _id }) => {
        let color = status === "complete" ? "green" : status === QuoteStatus.REQUEST ? "yellow" : status === QuoteStatus.RECEIVED ? "blue" : "magenta";
        return (
          <a><Tag onClick={(e) => !(status === QuoteStatus.FULLFILL) ? /* changeStatus(_id) */ null : null} color={color} key={status}>
            {
              status === QuoteStatus.REQUEST ? "Request" :
                status === QuoteStatus.RECEIVED ? "Received" :
                  status === QuoteStatus.FULLFILL ? "Requirement FullFilled" : null
            }
          </Tag></a>
        );
      },
    },
    {
      title: "Quote On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return (
          moment(created_at).format('DD-MMM-YYYY')
        );
      },
      sorter: (a, b) => {
        let nameA = a.created_at;
        let nameB = b.created_at;
        if (nameA < nameB)
          return -1;
        if (nameA > nameB)
          return 1;
        return 0;
      },
    },
    {
      title: "Action",
      fixed: 'right',
      render: (_, record) => {
        return (
          <>
            <Tooltip title="View Quote" color={"purple"} key={"viewquote"}>
              <Button onClick={(e) => view(record._id)}>
                <i className="fa fa-light fa-eye"></i>
              </Button>
            </Tooltip>
            {
              record.status == QuoteStatus.RECEIVED &&
              <Tooltip title="View Quote Reply" color={"purple"} key={"viewquote"}>
                <Button onClick={(e) => {
                  setSelectedQuote(record._id)
                  showModal(true)
                }}>
                  <i className="fas fa-comment"></i>
                </Button>
              </Tooltip>
            }
          </>
        );
      },
    },
  ];

  const handleCategory = (e) => {
    setCategoryIds(e)
    setPagination(prev => ({ ...prev, current: 1 }))
  };

  useEffect(() => {
    getCategoryList()
    getBrandList()
  }, [])

  useEffect(() => {
    setLoading(true)
    fetchData({ current: 1 }, selectedTab)
  }, [refresh, debouncedSearchText, categoryIds, brandIds, selectedTab])

  const handleTabChange = (status) => {
    setSelectedTab(status)
    // fetchData(pagination, '', status)
  };

  const fetchData = (pagination, status) => {
    setLoading(true)

    const payload = {};
    payload.page = pagination ? pagination.current : 1;
    payload.limit = pagination ? pagination?.pageSize : 10;
    payload.status = selectedTab ? selectedTab : "all";
    payload.search = debouncedSearchText;
    payload.brand_ids = brandIds ? brandIds : "";
    payload.category_ids = categoryIds ? categoryIds : "";
    request({
      url: api.list,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        setList(data.data.list.docs)
        setPagination(prev => ({ ...prev, current: pagination.current, total: data.data.list.totalDocs }))
      },
      onError: (error) => {
        setLoading(false)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const excelData = list.map(row => ({
    "Name": row.user_id && row.user_id.name ? row.user_id.name : '-',
    "Quote Id": row.quote_id ? row.quote_id : '-',
    "Request Type": row.request_type ? row.request_type : '-',
    "Category": row.category_id && row.category_id.name ? row.category_id.name : '-',
    "Part Type": row.part_type ? row.part_type : '-',
    "Part Number": row.part_number ? row.part_number : '-',
    "Service": row?.service_id?.name ? row?.service_id?.name : '-',
    "Vehicle Type": row?.type_id?.name || '-',
    "Vehicle Make": row?.make_id?.name || '-',
    "Vehicle Model": row?.model_id?.name || '-',
    "Vehicle Variant": row?.variant_id?.name || '-',
    "Location": row?.user_id?.name || '-',
    "Location": row?.user_id?.mobile_number ? (row?.user_id?.country_code +'-'+row?.user_id?.mobile_number) : '-',
    "Location": row?.user_id?.location || '-',
    "Description": row.description ? row.description : '-',
    "Amount (ZAR)": row.amount ? row.amount : '-',
    "Status": row.is_active ? 'Active' : 'Inactive',
    "Quote On": moment(row.created_at).format("DD-MM-YYYY"),
  }));

  const handleChange = (pagination, filters) => {
    fetchData(pagination);
  }

  const onSearch = (e) => {
    setSearchText(e.target.value)
    setPagination({ current: 1 })
  };

  return (
    <>
      <div className="tabled quoteManagement">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + " Management"}
              extra={
                <>
                  <Search
                    allowClear
                    size="small"
                    maxWidth={282}
                    onChange={onSearch}
                    onPressEnter={onSearch}
                    value={searchText}
                    placeholder="Search By Customer, Vehicle, Category"
                  />
                  <div className="button_group justify-content-end w-100">
                    <Button title="Export" onClick={(e) => DownloadExcel(excelData, sectionName)}><i class="fas fa-cloud-download-alt"></i>&nbsp;&nbsp;Export</Button>
                  </div>
                </>
              }
            >

              <Row gutter={[24, 0]} className="mb-24">
                <Col xs={24} xl={24} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div className="selectQuote" style={{ display: "flex", alignItems: "end", gap: "8px", width: "100%" }}>
                    {/* <Select style={{ width: '100%' }} value={brandIds} placeholder="Filter By Brand (Multiple)" mode="multiple" name="brand_id" onChange={handleBrand}>
                      {brandList && brandList && brandList.length > 0 ? brandList.map((item, index) => (
                        <option key={index} value={item._id}> {item.name} </option>
                      )) : null}
                    </Select> */}
                    <Select style={{ width: '100%' }} value={categoryIds} placeholder="Filter By Category (Multiple)" mode="multiple" name="categrory_id" onChange={handleCategory}>
                      {categoryList && categoryList.length > 0 ? categoryList.map((item, index) => (
                        <option key={index} value={item._id}> {item.name} </option>
                      )) : null}
                    </Select>
                  </div>

                  <Button onClick={handleReset}><i class="fas fa-sync-alt"></i></Button>
                </Col>
              </Row>


              <Tabs onTabClick={handleTabChange} activeKey={selectedTab} tabBarStyle={{ color: 'green' }}>
                <TabPane tab="All Quotes" key="all">
                  <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
                  <div className="table-responsive customPagination">
                    <Table
                      loading={loading}
                      columns={columns}
                      dataSource={list}
                      pagination={{ defaultPageSize: 10, responsive: true, total: pagination.total, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50'] }}
                      onChange={handleChange}
                      className="ant-border-space"
                    />
                  </div>
                </TabPane>

                <TabPane tab="New Requested" key={QuoteStatus.REQUEST}>
                  <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
                  <div className="table-responsive customPagination">
                    <Table
                      loading={loading}
                      columns={columns}
                      dataSource={list}
                      pagination={{ defaultPageSize: 10, responsive: true, total: pagination.total, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50'] }}
                      onChange={handleChange}
                      className="ant-border-space"
                    />
                  </div>
                </TabPane>

                <TabPane tab="Quotes Received" key={QuoteStatus.RECEIVED}>
                  <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
                  <div className="table-responsive customPagination">
                    <Table
                      loading={loading}
                      columns={columns}
                      dataSource={list}
                      pagination={{ defaultPageSize: 10, responsive: true, total: pagination.total, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50'] }}
                      onChange={handleChange}
                      className="ant-border-space"
                    />
                  </div>
                </TabPane>

                <TabPane tab="Requirement Fulfilled" key={QuoteStatus.FULLFILL}>
                  <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
                  <div className="table-responsive customPagination">
                    <Table
                      loading={loading}
                      columns={columns}
                      dataSource={list}
                      pagination={{ defaultPageSize: 10, responsive: true, total: pagination.total, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50'] }}
                      onChange={handleChange}
                      className="ant-border-space"
                    />
                  </div>
                </TabPane>

              </Tabs>
            </Card>
          </Col>
        </Row>
        {
          modal &&
          <ShowReply
            show={modal}
            hide={() => {
              showModal(false)
              setSelectedQuote()
            }}
            quoteId={selectedQuote}
          />

        }
      </div>
    </>
  );
}

const ShowReply = ({ show, hide, quoteId }) => {

  const [form] = Form.useForm();
  const { request } = useRequest()
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([])
  const [searchText, setSearchText] = useState('');
  const debouncedSearchText = useDebounce(searchText, 300);


  const fetchData = (pagination) => {
    setLoading(true)

    const payload = {};
    payload.page = pagination ? pagination.current : 1;
    payload.limit = pagination ? pagination.pageSize : 10;
    payload.search = debouncedSearchText;

    request({
      url: apiPath.replyListQuote + `/${quoteId}`,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        setList(data.data.list.docs)
        setPagination(prev => ({ current: pagination.current, total: data.data.list.totalDocs }))
      },
      onError: (error) => {
        setLoading(false)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  }

  const columns = [
    {
      title: "Specialist/Dealer",
      render: (_, { vendor_id }) => {
        return vendor_id ?
          <a
            target="_blank"
            rel="noreferrer noopener"
            className="cap" href={`/user/${vendor_id.type.toLowerCase()}/view/${vendor_id._id}`}>{(vendor_id ? `${vendor_id.name} (${vendor_id.type})` : '-')}</a> : '-';
      },
    },
    {
      title: "Amount (" + PRICE + ")",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Reply On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return (
          moment(created_at).format('DD-MMM-YYYY')
        );
      },
    },
    // {
    //   title: "Action",
    //   fixed: 'right',
    //   render: (_, record) => {
    //     return (
    //       <>
    //         <Tooltip title="View Quote" color={"purple"} key={"viewquote"}>
    //           <Button onClick={(e) => null}>
    //             <i className="fa fa-light fa-eye"></i>
    //           </Button>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
  ];

  useEffect(() => {
    if (!quoteId) return
    fetchData(pagination)
  }, [quoteId])


  return (
    <Modal
      open={show}
      width={800}
      title={`Reply On Quotes`}
      okText="Ok"
      footer={null}
      onCancel={hide}
    >

      <Table
        loading={loading}
        columns={columns}
        dataSource={list}
        pagination={{ defaultPageSize: 10, responsive: true, total: pagination.total }}
        onChange={handleChange}
        className="ant-border-space"
      />

    </Modal>
  )
}

export default Index;


